import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

import { DevicePlatformEnum } from './filterMappings.js';
import { TaskItemSchema } from './tasks.js';

export const TrackersQuerySchema = z.object({
  settingsId: z.string(),
  platformId: z.string(),
  platformName: z.string(),
  mediaRowId: z.string(),
  taxonomyItemId: z.string().optional(),
  taxonomyItemExternalId: z.string().optional(),
});

export const TrackerSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDuplicated: z.boolean().optional(),
  filterMappingExternalId: z.string().optional(),
  adformTagId: z.string().optional(),
  extra: z.object({
    campaignManagerCampaignId: z.string().nullable(),
    appsflyerMediaSourceId: z.string().nullable(),
    appsflyerDevicePlatform: DevicePlatformEnum.nullable(),
    adformIsRtb: z.boolean().nullable(),
    adformLineItemId: z.string().nullable(),
    adformTagId: z.string().nullable(),
    adformTagName: z.string().nullable(),
    adformContentType: z.number().nullable(),
    adformAdType: z.number().nullable(),
  }),
});

export const TrackersResponseSchema = createResponseSchema(TrackerSchema);

export const CreateTrackersRequestSchema = z.object({
  platformId: z.string(),
  platformName: z.string(),
  mediaRowId: z.string(),
  taxonomyItemId: z.string(),
  taxonomyItemExternalId: z.string(),
  taxonomyCampaignId: z.string(),
  taxonomyCampaignExternalId: z.string(),
  taxonomyAdGroupId: z.string().nullish(),
  taxonomyAdGroupExternalId: z.string().nullish(),
  taxonomyAdId: z.string().nullish(),
  taxonomyAdExternalId: z.string().nullish(),
  trackers: z.array(TrackerSchema.omit({ extra: true })).min(1),
});

export const CreateCmTrackingTrackerItemSchema = z.object({
  platformId: z.string(),
  platformName: z.string(),
  mediaRowId: z.string(),
  taxonomyItemId: z.string(),
  taxonomyItemExternalId: z.string(),
  taxonomyCampaignId: z.string(),
  taxonomyCampaignExternalId: z.string(),
  taxonomyAdGroupId: z.string().nullish(),
  taxonomyAdGroupExternalId: z.string().nullish(),
  taxonomyAdId: z.string().nullish(),
  taxonomyAdExternalId: z.string().nullish(),
  activityFilterMappingId: z.string(),
  platformFilterMappingId: z.string(),
  landingPageUrl: z.url(),
  startDate: z.string(),
  endDate: z.string(),
});

export const CreateCmTrackingTrackersRequestSchema = z
  .array(CreateCmTrackingTrackerItemSchema)
  .min(1);

export const CreateTrackersTaskResponseSchema =
  createResponseSchema(TaskItemSchema);

export const CreateCmTrackingTrackersResponseSchema =
  CreateTrackersTaskResponseSchema;

export const CreateCmDisplayTrackerItemSchema =
  CreateCmTrackingTrackerItemSchema.extend({
    assetIds: z.array(z.string()),
  });

export const CreateCmDisplayDefaultCreativeSchema = z.object({
  activityFilterMappingId: z.string(),
  assetId: z.string(),
});

export const CreateCmDisplayTrackersRequestSchema = z.object({
  trackers: z.array(CreateCmDisplayTrackerItemSchema).min(1),
  defaultCreatives: z.array(CreateCmDisplayDefaultCreativeSchema),
});

export const CreateCmDisplayTrackersResponseSchema =
  CreateTrackersTaskResponseSchema;

export const CreateAdformTrackingTrackerItemSchema = z.object({
  platformId: z.string(),
  platformName: z.string(),
  mediaRowId: z.string(),
  mediaRowFilterMappingId: z.string(),
  landingPageId: z.string(),
  taxonomyItemId: z.string(),
  taxonomyItemExternalId: z.string(),
  taxonomyCampaignId: z.string(),
  taxonomyCampaignExternalId: z.string(),
  taxonomyAdGroupId: z.string().nullish(),
  taxonomyAdGroupExternalId: z.string().nullish(),
  taxonomyAdId: z.string().nullish(),
  taxonomyAdExternalId: z.string().nullish(),
});

export const CreateAdformTrackingTrackersRequestSchema = z
  .array(CreateAdformTrackingTrackerItemSchema)
  .min(1);

export const CreateAdformTrackingTrackersResponseSchema =
  CreateTrackersTaskResponseSchema;

export const CreateAdformDisplayTrackerItemSchema =
  CreateAdformTrackingTrackerItemSchema.extend({
    assetIds: z.array(z.string()).min(1),
  });

export const CreateAdformDisplayTrackersRequestSchema = z
  .array(CreateAdformDisplayTrackerItemSchema)
  .min(1);

export const CreateAdformDisplayTrackersResponseSchema =
  CreateTrackersTaskResponseSchema;

export const DeleteTrackersQuerySchema = z.object({
  settingsId: z.string(),
  taxonomyItemId: z.string(),
  taxonomyItemExternalId: z.string(),
  trackerMappingId: z.string().array().min(1),
  platformName: z.string(),
});
